export const VerificationSchema = {
    security_pin: [
        { rule: "required", message: "The activation code field is required." }
    ],
}